export default __webpack_public_path__ + "static/media/lms_icon.7df95331.png";